// <----------cart sidebar js start---------->
  class SidebarDrawer extends HTMLElement {
    open() { this.setAttribute('open', '');  initCustomSlickSlider(this.querySelector('#recently-viewed'));  }
    close() { this.removeAttribute('open'); }
    connectedCallback() {
      this.querySelector('.close-btn')
        .addEventListener('click', () => this.close());
    }
  }
  customElements.define('sidebar-drawer', SidebarDrawer);

  document.addEventListener('DOMContentLoaded', function() {
    var sidebar = document.querySelector('sidebar-drawer');
    var cartIcon = document.getElementById('headerCartIcon');

    // Add this block for the cart icon
    if(cartIcon && sidebar) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        sidebar.open();
       
      });
    }
  });
// <----------cart sidebar js end---------->




// <---------- Slider JS start ---------->

function initCustomSlickSlider(container) {
  $(container).find('.custom-slick-slider').each(function () {
    var $slider = $(this);

    // Destroy if already initialized
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // Dynamic attributes
    var slidesMobile  = parseInt($slider.data('slides-mobile'))  || 1;
    var slidesTablet  = parseInt($slider.data('slides-tablet'))  || 2;
    var slidesLaptop  = parseInt($slider.data('slides-laptop'))  || 3;
    var slidesDesktop = parseInt($slider.data('slides-desktop')) || 4;

    var autoplay  = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
    var speed     = parseInt($slider.data('speed')) || 3000;
    var showArrows = $slider.data('arrows') === true || $slider.data('arrows') === 'true';
    var showDots   = $slider.data('dots') === true || $slider.data('dots') === 'true';

    // Add loaded class on init
    $slider.on('init', function () {
      $slider.addClass('slider-loaded');
    });

    // Initialize slick
    $slider.slick({
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      infinite: false, // 🔥 IMPORTANT: stop at last product
      dots: showDots,
      arrows: showArrows,
      autoplay: autoplay,
      autoplaySpeed: speed,
      pauseOnHover: true,
      pauseOnFocus: true,

      prevArrow: `
        <button type="button" class="slick-prev slick-arrow" aria-label="Previous">
          <svg fill="#000000" width="64px" height="64px" viewBox="0 0 512 512">
            <path d="M297.2,478l20.7-21.6L108.7,256L317.9,55.6L297.2,34L65.5,256L297.2,478z
                     M194.1,256L425.8,34l20.7,21.6L237.3,256l209.2,200.4L425.8,478L194.1,256z"/>
          </svg>
        </button>`,

      nextArrow: `
        <button type="button" class="slick-next slick-arrow" aria-label="Next">
          <svg fill="#000000" width="64px" height="64px" viewBox="0 0 512 512">
            <path d="M214.78,478l-20.67-21.57L403.27,256
                     194.11,55.57,214.78,34,446.46,256ZM317.89,256
                     86.22,34,65.54,55.57,274.7,256,65.54,456.43,86.22,478Z"/>
          </svg>
        </button>`,

      responsive: [
        {
          breakpoint: 1400,
          settings: { slidesToShow: slidesLaptop }
        },
        {
          breakpoint: 1000,
          settings: { slidesToShow: slidesTablet }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: slidesMobile }
        }
      ]
    });
    
    // 🔹 Stop autoplay when last slide is reached
    $slider.on('afterChange', function (event, slick, currentSlide) {
      if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
        $slider.slick('slickPause');
      }
    });
  });
}

// 🔹 Normal frontend load
$(document).ready(function () {
  initCustomSlickSlider(document);
});

// 🔹 Shopify Editor Events
document.addEventListener('shopify:section:load', function (event) {
  initCustomSlickSlider(event.target);
});

document.addEventListener('shopify:section:select', function (event) {
  initCustomSlickSlider(event.target);
});

document.addEventListener('shopify:block:select', function (event) {
  initCustomSlickSlider(event.target);
});

document.addEventListener('shopify:block:deselect', function (event) {
  initCustomSlickSlider(event.target);
});

// 🔹 Fallback
document.addEventListener('shopify:section:deselect', function () {
  initCustomSlickSlider(document);
});

// <---------- Slider JS end ---------->



// <----------Tab click logic JS start---------->
$(document).on('click', '.tab-link', function () {
  const tabId = $(this).data('tab');

  // switch active tab/link
  $(this).addClass('active').siblings().removeClass('active');
  $('#' + tabId).addClass('active').siblings('.tab-content').removeClass('active');

  // :large_green_circle: Re-init slick for sliders inside the newly opened tab
  initCustomSlickSlider('#' + tabId);
});
// <----------Tab click logic JS end---------->





// document.addEventListener("DOMContentLoaded", function () {
//   // Step 0: reset all items to initial state
//   const items = document.querySelectorAll(".reveal-on-scroll, .is-visible");
//   items.forEach(el => {
//     el.classList.add("reveal-on-scroll"); // ensure initial class is present
//     el.classList.remove("is-visible");    // hide them
//   });

//   if (!("IntersectionObserver" in window)) {
//     items.forEach(el => el.classList.add("is-visible"));
//     return;
//   }

//   // Group items by parent section/container
//   const sections = {};
//   document.querySelectorAll(".reveal-on-scroll").forEach(item => {
//     const parent = item.closest('section, .product-section, .container') || document.body;
//     const parentKey = parent.className || 'default';
//     if (!sections[parentKey]) sections[parentKey] = [];
//     sections[parentKey].push(item);
//   });

//   const observer = new IntersectionObserver((entries, observer) => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) return;

//       const parent = entry.target.closest('section, .product-section, .container') || document.body;
//       const parentKey = parent.className || 'default';
//       const groupItems = sections[parentKey];

//       groupItems.forEach((item, index) => {
//         setTimeout(() => {
//           item.classList.add("is-visible");

//           // Remove classes after animation ends
//           const onTransitionEnd = () => {
//             item.classList.remove("reveal-on-scroll");
//             item.classList.remove("is-visible");
//             item.removeEventListener("transitionend", onTransitionEnd);
//           };
//           item.addEventListener("transitionend", onTransitionEnd);

//         }, index * 80); // stagger delay
//       });

//       groupItems.forEach(item => observer.unobserve(item));
//     });
//   }, { threshold: 0.2 });

//   document.querySelectorAll(".reveal-on-scroll").forEach(el => observer.observe(el));
// });









document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".reveal-on-scroll");

  // Hide initially
  items.forEach(el => el.classList.remove("is-visible"));

  // Fallback for old browsers
  if (!("IntersectionObserver" in window)) {
    items.forEach(el => el.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const item = entry.target;
      const parent = item.parentElement;
      const siblings = parent.querySelectorAll(".reveal-on-scroll");

      // GRID / MULTIPLE ITEMS
      if (siblings.length > 1) {
        siblings.forEach((sibling, index) => {
          setTimeout(() => {
            sibling.classList.add("is-visible");

            setTimeout(() => {
              sibling.classList.remove("reveal-on-scroll");
            }, 600);
          }, index * 80);
        });

        siblings.forEach(sibling => observer.unobserve(sibling));
      }
      // SINGLE ITEM
      else {
        item.classList.add("is-visible");

        setTimeout(() => {
          item.classList.remove("reveal-on-scroll");
        }, 600);

        observer.unobserve(item);
      }
    });
  }, {
    threshold: 0.2,
    // rootMargin: "-85% 0px -15% 0px"
  });

  items.forEach(item => observer.observe(item));
});


/* ================================
 Add to cart popup start
================================ */
let cartNotificationTimer = null;

/* 🔥 LISTEN TO SHOPIFY CART UPDATE */
document.addEventListener('cart:updated', function (event) {
  if (!event.detail || !event.detail.addedItem) return;
  showCartNotification(event.detail.addedItem);
});

/* 🔥 FALLBACK FOR THEMES WITHOUT cart:updated */
// document.addEventListener('submit', function (e) {
//   const form = e.target.closest('form[action="/cart/add"]');
//   if (!form) return;

//   // Let Shopify submit normally
//   setTimeout(() => {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         const lastItem = cart.items[cart.items.length - 1];
//         if (lastItem) {
//           showCartNotification(lastItem);
//         }
//       });
//   }, 300);
// });

/* POPUP FUNCTION */
// function showCartNotification(item) {
//   const notification = document.getElementById('cart-notification');

//   document.getElementById('cart-notification-image').src = item.image;
//   document.getElementById('cart-notification-title').textContent = item.product_title;
//   document.getElementById('cart-notification-variant').textContent =
//     item.variant_title && item.variant_title !== 'Default Title'
//       ? item.variant_title
//       : '';

//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       document.getElementById('cart-notification-count').textContent = cart.item_count;
//     });

//   notification.classList.remove('hidden');
//   notification.classList.add('active');

//   if (cartNotificationTimer) clearTimeout(cartNotificationTimer);

//   cartNotificationTimer = setTimeout(() => {
//     notification.classList.remove('active');
//     notification.classList.add('hidden');
//   }, 4000);
// }


/* POPUP FUNCTION */

function showCartNotification(item) {

  // 🚫 DO NOT OPEN POPUP IF BLOCKED
  if (window.blockCartNotification) {
    window.blockCartNotification = false; // reset for next valid add
    return;
  }

  const notification = document.getElementById('cart-notification');

  document.getElementById('cart-notification-image').src = item.image;
  document.getElementById('cart-notification-title').textContent = item.product_title;
  document.getElementById('cart-notification-variant').textContent =
    item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title
      : '';

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document.getElementById('cart-notification-count').textContent = cart.item_count;
    });

  notification.classList.remove('hidden');
  notification.classList.add('active');

  if (cartNotificationTimer) clearTimeout(cartNotificationTimer);

  cartNotificationTimer = setTimeout(() => {
    notification.classList.remove('active');
    notification.classList.add('hidden');
  }, 4000);
}


/* MANUAL CLOSE */
document.addEventListener('click', function (e) {
  if (
    e.target.classList.contains('cart-notification__close') ||
    e.target.classList.contains('continue-shopping')
  ) {
    const notification = document.getElementById('cart-notification');
    notification.classList.remove('active');
    notification.classList.add('hidden');

    if (cartNotificationTimer) clearTimeout(cartNotificationTimer);
  }
});

/* ================================
 Add to cart popup end
================================ */
/* ================================
  Related Products Slider
================================ */
function initRelatedProductsSlider() {
  if (
    typeof jQuery === 'undefined' ||
    typeof jQuery.fn.slick === 'undefined'
  ) {
    console.warn('jQuery or Slick not loaded');
    return;
  }

  const $slider = jQuery('.related-products-slick');

  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      prevArrow: `
        <button type="button" class="slick-prev">
          <svg fill="currentColor" width="24" height="24" viewBox="0 0 512 512">
            <path d="M297.2,478l20.7-21.6L108.7,256L317.9,55.6L297.2,34L65.5,256L297.2,478z M194.1,256L425.8,34l20.7,21.6L237.3,256l209.2,200.4L425.8,478L194.1,256z"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next">
          <svg fill="currentColor" width="24" height="24" viewBox="0 0 512 512">
            <path d="M214.8,34l-20.7,21.6L403.3,256L194.1,456.4L214.8,478L446.5,256L214.8,34z M317.9,256L86.2,478l-20.7-21.6L274.7,256L65.5,55.6L86.2,34L317.9,256z"/>
          </svg>
        </button>
      `,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
  initRelatedProductsSlider();
});

// Re-initialize after AJAX cart updates
document.addEventListener('cart:updated', function () {
  const $slider = jQuery('.related-products-slick');
  
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  
  setTimeout(() => {
    initRelatedProductsSlider();
  }, 100);
});

// Handle Shopify section reloads
document.addEventListener('shopify:section:load', function () {
  setTimeout(() => {
    initRelatedProductsSlider();
  }, 100);
});



document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.add-to-cart-btn');
  if (!btn) return;

  // small delay so theme JS finishes first
  setTimeout(() => {
    btn.style.display = 'block';
  }, 300);
});



// The "View Subscription Policy" link opens in a new tab.



// document.addEventListener("DOMContentLoaded", function () {
//   const link = document.querySelector(".shopify_subscriptions_app_policy a");

//   if (link) {
//     link.setAttribute("target", "_blank");
//     link.setAttribute("rel", "noopener noreferrer");
//   }
// });


// **One-time Purchase will be selected by default.**

// document.addEventListener("DOMContentLoaded", function () {
//   function setDefaultOneTime() {
//     const oneTime = document.querySelector(
//       'input[data-radio-type="one_time_purchase"]'
//     );

//     if (!oneTime) return;

//     oneTime.checked = true;
//     oneTime.dispatchEvent(new Event("change", { bubbles: true }));
//     oneTime.dispatchEvent(new Event("click", { bubbles: true }));
//   }

//   setDefaultOneTime();

//   document.addEventListener("shopify:section:load", setDefaultOneTime);
// });